// Form field constants
export const FORM_FIELDS = {
  // Identity fields
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  DISPLAY_NAME: 'displayName',
  EMAIL: 'email',

  // Contact fields
  PHONE: 'phone',
  PHONE_FORMATTED: 'phoneFormatted',
  MOBILE_PHONE: 'mobilePhone',
  STREET_ADDRESS: 'streetAddress',
  CITY: 'city',
  STATE: 'state',
  POSTAL_CODE: 'postalCode',
  COUNTRY: 'country',
  USAGE_LOCATION: 'usageLocation',
  OTHER_MAILS: 'otherMails',
  FAX: 'fax',

  // Job fields
  DEPARTMENT: 'department',
  JOB_TITLE: 'jobTitle',
  COMPANY_NAME: 'companyName',
  OFFICE_LOCATION: 'officeLocation',
  EMPLOYEE_ID: 'employeeId',
  EMPLOYEE_TYPE: 'employeeType',
  HIRE_DATE: 'hireDate',
  MANAGER: 'manager',

  // Groups
  M365_GROUPS: 'm365Groups',
  SECURITY_GROUPS: 'securityGroups',

  // Licenses
  LICENSES: 'licenses',

  // Settings
  ENABLE_POWERSHELL_ACCESS: 'enablePowershellAccess',
}
